import Input from '~/components/common/input';
import cn from 'classnames';
import { useRouter } from 'next/router';
import Checkboxes from './checkboxes';
import React, { useState } from 'react';
import { useEffect } from 'react';

export type Childs = {
   _id: string;
   slug: string;
   total_venues?: number;
   title: {
      ar: string;
      en: string;
   };
};

type GroupedCheckboxProps = {
   name: string;
   label: React.ReactNode;
   childs?: Childs[];
   id: string;
   last?: boolean;
   // eslint-disable-next-line no-unused-vars
   onChange?: (name: string, checked: boolean, childs?: Childs[]) => void;
   // eslint-disable-next-line no-unused-vars
   onChildChange?: (name: string, checked: boolean) => void;
   mobile?: boolean;
   value?: boolean;
   sub_values?: string[];
   count?: number;
};

export const GroupedCheckbox = ({
   name,
   label,
   childs,
   id,
   last,
   onChange,
   onChildChange,
   mobile,
   value,
   sub_values,
}: // count,
GroupedCheckboxProps) => {
   const [checked, setChecked] = useState(false);
   const router = useRouter();

   useEffect(() => {
      if (router.query.categories?.includes(name)) setChecked(true);
   }, [router, name]);

   useEffect(() => {
      /**
       * Used in mobile only with reset button
       */
      setChecked(!!value);
      if (router.query[name] || router.query.categories?.includes(name)) setChecked(true);
   }, [value, router, name]);

   return (
      <div>
         <div className="flex">
            <Input
               type="checkbox"
               labelClassName={cn('text-[15px] sm:text-[15px]')}
               className={cn('items-center focus:outline-none', !last && 'mb-4')}
               name={name}
               label={
                  <div>
                     {label}{' '}
                     {/* {count ? <span className="text-sm text-gray-500">({count})</span> : null} */}
                  </div>
               }
               checked={checked}
               id={id + (mobile ? '-mobile' : '')}
               onChange={(e: React.FormEvent<HTMLInputElement>) => {
                  setChecked(e.currentTarget.checked);
                  onChange?.(name, e.currentTarget.checked, childs);
               }}
            />
         </div>
         {checked && childs ? (
            <div className="ltr:pl-[29px] rtl:pr-[29px]">
               {childs.map(({ title, slug, _id, total_venues }) => (
                  <div className="flex" key={_id}>
                     <Checkboxes
                        id={slug + (mobile ? '-mobile' : '')}
                        key={`${slug}-category`}
                        name={slug}
                        label={title}
                        isChild
                        count={total_venues}
                        onChange={onChildChange}
                        value={sub_values?.includes(slug)}
                     />
                  </div>
               ))}
            </div>
         ) : null}
      </div>
   );
};
